import React from "react";
import { Tooltip } from "@lululemon/ecom-pattern-library-tooltip";
import { Icon } from "@lululemon/ecom-pattern-library-icon";
import {
  infoIcon,
  afterpayIcon,
  klarnaIcon
} from "@lululemon/ecom-pattern-library-icons";
import { domPurify } from "@lululemon/ufs-shared";

import styles from "../styles/installment-payments.module.scss";

const NUMBER_OF_PAYMENTS = 4;

const roundPrice = (price) =>
  (Math.round((price * 100) / NUMBER_OF_PAYMENTS) / 100).toFixed(2);

const InstallmentPayments = ({
  showAfterPay,
  showKlarna,
  price,
  tooltipText
}) => {
  return (
    (showAfterPay || showKlarna) && (
      <div className={styles.installmentPayments}>
        <span>
          <span className="OneLinkTx">{`${NUMBER_OF_PAYMENTS} payments of $${roundPrice(
            price
          )} available with`}</span>
          {showAfterPay && (
            <Icon
              className={styles.afterpayIcon}
              content={afterpayIcon}
              aria-label="afterpay"
            />
          )}
          {showKlarna && (
            <>
              {showAfterPay && "or"}
              <Icon
                className={styles.klarnaIcon}
                content={klarnaIcon}
                aria-label="klarna"
              />
            </>
          )}
        </span>
        <Tooltip
          aria-label="Installments payment tooltip"
          disclosure={
            <button
              aria-label="Installments payment tooltip"
              className={`lll-text-primary ${styles.tooltipButton}`}
              type="button"
            >
              <Icon className={styles.tooltipIcon} content={infoIcon} />
            </button>
          }
          placement="bottom"
        >
          <span
            className={styles.tooltipText}
            dangerouslySetInnerHTML={domPurify(tooltipText)}
          />
        </Tooltip>
      </div>
    )
  );
};

export default InstallmentPayments;
